import { emptyNextCorrection } from '../../did-you-mean/did-you-mean-state.js';
export function getDidYouMeanInitialState() {
    return {
        wasCorrectedTo: '',
        queryCorrection: emptyNextCorrection(),
        originalQuery: '',
    };
}
